export default {

    numberWithCommas(x, minFractions=false) {
        if(!minFractions) {
            return x.toLocaleString();
        } else {
            return x.toLocaleString(undefined, { minimumFractionDigits: 5 }).toString();
        }
    }
}